<aionz-header-bottom-sheet aionz-dialog-title (onClose)="handleClose()">
  FOCs para assinatura
</aionz-header-bottom-sheet>

<div
  aionz-dialog-content
  class="foc-list">
  <span>Fornecedores:</span>

  @for (foc of data.focs; track $index) {
    <div class="foc-item">
      <span>{{ foc.supplierName }}</span>

      <button
        mat-flat-button
        color="primary"
        (click)="handleViewFoc(foc.focUrl)">
        Ver FOC
      </button>
    </div>
  }
</div>
